export default {
    root:{
        minWidth:"fit-content",
        margin:"dense"
    }
}